import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-project-summary-flipper__card" }
const _hoisted_2 = { class: "gfu-project-summary-flipper__front" }
const _hoisted_3 = { class: "gfu-project-summary-flipper__back" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-project-summary-flipper', { 'is-flipped': $props.isFlipped }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "front")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "back")
      ])
    ])
  ], 2 /* CLASS */))
}